<template>
  <div class="filter-mode-check">
    <div class="item tableIconHover" v-for="(item,index) in iconList" :key="item.key" :class="{'check': item.key === selectKey}" @click="checkMode(index)">
      <toolTip show :title="item.text">
        <i :class="`icon iconfont ${item.icon}`"></i>
      </toolTip>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    iconList: {
      type: Array,
      default: () => []
    },
    selectKey: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
    }
  },
  methods: {
    checkMode(val) {
      this.$emit('select', val)
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/mixin.scss";
.filter-mode-check {
  display: flex;
  align-items: center;
  padding: 3px;
  @include bgColorOpacity(.08);
  border-radius: 6px;
  margin-left: 16px;
  .item {
    box-sizing: border-box;
    width: 26px;
    height: 26px;
    text-align: center;
    border-radius: 4px;
    @include fontColorOpacity(.6);
    font-size: 12px;
    cursor: pointer;
    &.check {
      background-color: #fff;
      @include fontColorOpacity(.8);
    }
  }
}
</style>
